import React, { useRef, useState } from 'react';
import * as api from '../../../api';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Section from '../../Atoms/Section';

const CandidatureForm = (props) => {

    const { i18n } = useTranslation('common');

    const navigate = useNavigate();
    const MesssageRef = useRef(null)
    const [selectedProjets, setSelectedProjets] = useState([])

    async function submitCandidature() {
        api.SubmitCadidature({
            userId: props.user._id,
            participationId: props.company.participation._id,
            message: MesssageRef.current.value,
            projets: selectedProjets
        }).then((response) => {
            console.log(response.data)
            if(response.data === "user already candidtates")
            {
                alert(i18n.language === "fr" ? "Vous avez déjà candidaté à cette entreprise" : "You have already applied to this company")
            }
            else if(response.data === "ok")
            {
                props.afterSubmitCandidature();
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    function selectProject(e){
        console.log(e.target.value)
        if(e.target.value !== "select"){
            setSelectedProjets([...selectedProjets, e.target.value])
        }
    }

    console.log("props.allUserData")
    console.log(props.allUserData)


    console.log("props.participation")
    console.log(props.participation)

    const projects = props.participation.data.projets;

    return (
        <div>
            <Section className="padding">
                <button onClick={props.onBack}>← {i18n.language === "fr" ? "Retour" : "Back"}</button><br/>
                <br/>
                {props.company && props.user && <>
                    <h1 className='centered'>{i18n.language === "fr" ? "Votre demande de rendez-vous avec" : "Your request for a meeting with"} {props.company.hsCompany?.properties?.name}</h1><br/>
                    <p>{i18n.language === "fr" ? "Nous vous recommandons de motiver votre demande en laissant un message. Celui-ci sera pris en compte lors de la réunion du comite de matching." : "We recommend you to motivate your request by leaving a message. This will be taken into account during the matching committee meeting."}</p><br/>
                    <br/>
                    <textarea ref={MesssageRef} placeholder={i18n.language === "fr" ? "Ajouter du texte (optionnel)" : "Add text (optional)"}></textarea><br/>
                    <br/>
                    {selectedProjets.map((proj) =>
                        <div style={{marginBottom:"20px"}} key={proj}>
                            <b>{projects.find(p => p._id === proj).title}</b><br/>
                            <span className='thin'>{projects.find(p => p._id === proj).description}</span><br/>
                            <span className='linkbutton' onClick={() => setSelectedProjets(selectedProjets.filter(p => p !== proj))}>{i18n.language === "fr" ? "Retirer" : "Remove"}</span><br/>
                        </div>
                    )}
                    <select onChange={selectProject} style={{minWidth:"200px"}}>
                        <option value="select">{i18n.language === "fr" ? "Ajoutez un projet" : "Add a project"}</option>
                        {projects.filter(proj => !selectedProjets.find(selproj => selproj === proj._id)).map((projet) => 
                            <option key={projet._id} value={projet._id}>{projet.title}</option>
                        )}
                    </select><br/>
                    {/* <span className='thin'>{i18n.language === "fr" ? "Vous pouvez enregistrer des projets depuis votre " : "You can save projects from your "}<span onClick={() => document.location.href = '/profile/manageevent?eid='+props.company.participation.eventId+'&panel=profile&step=3'} className='linkbutton'>{i18n.language === "fr" ? "Profil" : "Profile"}</span></span><br/> */}
                    <br/>
                    <button className='centered' onClick={submitCandidature}>{i18n.language === "fr" ? "Valider la demande" : "Confirm request"}</button>
                    <br/>
                    <button onClick={props.onBack}>← {i18n.language === "fr" ? "Retour" : "Back"}</button><br/>
                </>}
            </Section>
        </div>
    );
};

export default CandidatureForm;